module.exports = __webpack_public_path__ + "img/13d.706d5a0e.png";